import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { press } from "@/mocks/home";

export default function Testimonial() {
  const root = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!root.current) return;
    const ctx = gsap.context(() => {
      gsap.from(".testi-line", {
        y: 30,
        opacity: 0,
        duration: 1.2,
        stagger: 0.08,
        ease: "power3.out",
        scrollTrigger: { trigger: root.current, start: "top 70%" },
      });
    }, root);
    return () => ctx.revert();
  }, []);

  const quote = "Verdant is what fashion looks like when it remembers it is made of plants, hands, and time.";
  const words = quote.split(" ");

  return (
    <section ref={root} className="bg-bone py-16 md:py-20 px-6 md:px-10">
      <div className="max-w-6xl mx-auto">
        <div className="relative bg-ink rounded-[28px] overflow-hidden px-8 md:px-16 py-12 md:py-16 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          <div className="lg:col-span-4">
            <div className="relative aspect-[3/4] rounded-2xl overflow-hidden lg:-ml-16 max-h-[320px]">
              <img
                src="https://readdy.ai/api/search-image?query=portrait%20of%20stylish%20woman%20wearing%20sustainable%20natural%20linen%20cream%20clothing%20looking%20away%2C%20warm%20natural%20outdoor%20light%2C%20editorial%20fashion%20portrait%20photography%2C%20artisanal%20slow%20fashion%20aesthetic%2C%20earth%20tone%20palette%2C%20minimal%20clean%20composition%2C%20serene%20intimate%20mood&width=700&height=900&seq=verdant-testi-1&orientation=portrait"
                alt="Editor quote"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
          <div className="lg:col-span-8">
            <i className="ri-double-quotes-l text-clay text-5xl md:text-7xl leading-none block"></i>
            <blockquote className="mt-4 font-display text-3xl md:text-5xl text-bone tracking-tightest font-light leading-[1.15]">
              {words.map((w, i) => (
                <span key={i} className="testi-line inline-block mr-2">
                  {w}
                </span>
              ))}
            </blockquote>
            <div className="mt-8 flex flex-col sm:flex-row items-start sm:items-center gap-6">
              <div>
                <p className="text-bone font-medium">Hanna Lindqvist</p>
                <p className="text-bone/60 text-sm">Editor-in-Chief, Kinfolk Magazine</p>
              </div>
              <a
                href="/story"
                className="bg-clay text-ink px-6 py-3 rounded-full text-xs uppercase tracking-wide font-medium hover:bg-bone transition-colors cursor-pointer whitespace-nowrap"
              >
                Read the feature →
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-x-10 gap-y-5 text-ink/30">
          <span className="text-[11px] font-mono uppercase tracking-[0.22em] text-ink/50">As featured in</span>
          {press.map((p) => (
            <span
              key={p}
              className="font-display text-2xl md:text-3xl font-light hover:text-ink transition-colors cursor-pointer"
            >
              {p}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}